import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Table, {
  Cell,
  Row,
  TitleCell,
  TitleRow
} from 'components/ReusableComponents/Table'
import moment from 'moment'
import { useEffect, useState } from 'react'
import complianceApi from 'services/api/compliance'

import styles from './UploadConsentLogsDialog.module.scss'

const subscriptionStatusName = {
  ConsentGiven: 'Consent Given',
  DoNotCall: 'Do Not Call'
}

const UploadConsentLogsDialog = ({ onClose }) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    complianceApi
      .getConsentUploads({
        startDate: moment().subtract(6, 'month').format('YYYY-MM-DD'),
        endDate: moment().add(1, 'day').format('YYYY-MM-DD')
      })
      .then(response => {
        setData(response)
        setIsLoading(false)
      })
  }, [])

  return (
    <ConfirmationDialog
      title="Uploaded consent logs"
      maxWidth={900}
      onClose={onClose}
      hasConfirmButton={false}
      theme="blacklist"
    >
      {isLoading && <LoadingIndicator />}
      {!isLoading && (
        <div className={styles.container}>
          <Table widths={[200, 200, 130, 100, 100]}>
            <TitleRow>
              <TitleCell>Uploaded by</TitleCell>
              <TitleCell>Uploaded on</TitleCell>
              <TitleCell>Type</TitleCell>
              <TitleCell>Total</TitleCell>
              <TitleCell>Updated</TitleCell>
            </TitleRow>
            {data
              .sort((a, b) => moment(b.uploadedOn).diff(moment(a.uploadedOn)))
              .map((item, index) => (
                <Row key={index}>
                  <Cell>
                    <span className={styles.cell}>{item.uploadedByName}</span>
                  </Cell>
                  <Cell>
                    <span className={styles.cell}>
                      {moment(item.uploadedOn).format('MMM DD, YYYY, hh:mm A')}
                    </span>
                  </Cell>
                  <Cell>
                    <span className={styles.cell}>
                      {subscriptionStatusName[item.subscriptionStatus]}
                    </span>
                  </Cell>
                  <Cell>
                    <span className={styles.cell}>{item.totalCount} guests</span>
                  </Cell>
                  <Cell>
                    <span className={styles.cell}>{item.updateCount} guests</span>
                  </Cell>
                </Row>
              ))}
          </Table>
        </div>
      )}
    </ConfirmationDialog>
  )
}

export default UploadConsentLogsDialog
